import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import {
    Hospitality,
    HospitalityUserWithCredentials,
} from '@/models/hospitality';

type GetHospitalityUsersResponse = {
    hospitalityUsers: HospitalityUserWithCredentials[];
};

export const hospitalityUrls = () => ({
    hospitality: urlBuilder('auth', 'hospitality'),
});

export const hospitalityApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['HOSPITALITY'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getHospitalityUsers: builder.query<
                GetHospitalityUsersResponse,
                void
            >({
                query: () => hospitalityUrls().hospitality,
                providesTags: ['HOSPITALITY'],
            }),

            postHospitality: builder.mutation<
                HospitalityUserWithCredentials,
                Hospitality
            >({
                query: (hospitalityUser) => ({
                    url: hospitalityUrls().hospitality,
                    method: 'POST',
                    body: hospitalityUser,
                }),
                invalidatesTags: ['HOSPITALITY'],
            }),

            putHospitality: builder.mutation<
                HospitalityUserWithCredentials,
                Hospitality & {
                    resetPassword: boolean;
                }
            >({
                query: (hospitalityArgs) => ({
                    url: `${hospitalityUrls().hospitality}/${
                        hospitalityArgs.id
                    }`,
                    method: 'PUT',
                    body: hospitalityArgs,
                }),
                invalidatesTags: ['HOSPITALITY'],
            }),

            deleteHospitality: builder.mutation<
                void,
                HospitalityUserWithCredentials
            >({
                query: (hospitality) => ({
                    url: `${hospitalityUrls().hospitality}/${hospitality.id}`,
                    method: 'DELETE',
                    body: hospitality,
                }),
                invalidatesTags: ['HOSPITALITY'],
            }),
        }),
    });

export const {
    useGetHospitalityUsersQuery,
    usePostHospitalityMutation,
    usePutHospitalityMutation,
    useDeleteHospitalityMutation,
} = hospitalityApi;
